import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Download, ShieldAlert, ShieldCheck } from 'lucide-react';
import { toast } from 'sonner';
import { api, downloadFile, errMsg, fmtDateTime } from '../api';
import { Card, SectionTitle } from '../ui';

const pdf = (path, name) => () => downloadFile(path, name).catch((e) => toast.error(errMsg(e)));

function Row({ hit, to, title, sub, onPdf, testid }) {
  const Icon = hit ? ShieldAlert : ShieldCheck;
  return (
    <div className="py-3 flex items-center gap-4" data-testid={testid}>
      <Icon size={18} className={hit ? 'text-[#E5484D]' : 'text-[#2E9E62]'} />
      <div className="flex-1 min-w-0">
        <Link to={to} className="text-sm text-[#F2F2F2] hover:text-[#D4AF37] truncate block" data-testid={`${testid}-open`}>{title}</Link>
        <p className="text-xs text-[#5A5F67] font-mono">{sub}</p>
      </div>
      {onPdf && <button onClick={onPdf} className="text-[#D4AF37] hover:text-white" data-testid={`${testid}-pdf`}><Download size={16} /></button>}
    </div>
  );
}

export function AmlChecksArchive() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get('/aml/checks').then((r) => setItems(r.data)).catch(() => {}); }, []);
  return (
    <Card className="p-6 mb-8" data-testid="archive-aml-list">
      <SectionTitle>Reputational check</SectionTitle>
      {!items.length ? <p className="text-sm text-[#5A5F67]">Nessun reputational check. Puoi avviarli da Reputational check o dai report.</p> : (
        <div className="divide-y divide-[#1F242C]">
          {items.map((c) => {
            const hits = (c.subjects || []).filter((s) => s.outcome === 'Riscontri presenti').length;
            const status = c.status === 'done' ? (hits ? `${hits} con riscontri` : 'nessun riscontro') : 'in corso';
            return <Row key={c.id} hit={hits > 0} to={`/portal/reputational/${c.id}`} title={c.label} testid={`archive-aml-${c.id}`}
              sub={`${fmtDateTime(c.created_at)} · ${(c.subjects || []).length} ${(c.subjects || []).length === 1 ? 'soggetto' : 'soggetti'} · ${status}`}
              onPdf={c.status === 'done' ? pdf(`/aml/checks/${c.id}/pdf`, `BOND_reputational_${c.id.slice(0, 8)}.pdf`) : null} />;
          })}
        </div>
      )}
    </Card>
  );
}

export function NegativeArchive() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get('/negative/requests').then((r) => setItems(r.data.filter((n) => n.source !== 'aml'))).catch(() => {}); }, []);
  if (!items.length) return null;
  return (
    <Card className="p-6 mb-8" data-testid="archive-negative-list">
      <SectionTitle>Negatività persone fisiche</SectionTitle>
      <div className="divide-y divide-[#1F242C]">
        {items.map((n) => <Row key={n.id} hit={!!n.positive} to="/portal/persone?tab=negativita" title={n.name} testid={`archive-negative-${n.id}`}
          sub={`${n.tax_code} · ${fmtDateTime(n.created_at)} · ${n.status === 'done' ? (n.positive ? 'esito positivo' : 'nessuna negatività') : n.status === 'pending' ? 'in corso' : 'non riuscita'}`}
          onPdf={n.status === 'done' ? pdf(`/negative/requests/${n.id}/pdf`, `BOND_negativita_${n.tax_code}.pdf`) : null} />)}
      </div>
    </Card>
  );
}
